import { useState } from "react";

// The preview's `[data-gw]` tracker: a count that steps up to the goal,
// unlocks the reward there, and resets to zero.
export function useGoalProgress(goal: number) {
  const initialState = { done: 0 };
  const [state, setState] = useState(initialState);

  const isComplete = state.done >= goal;
  const add = () =>
    setState((state) => ({ ...state, done: Math.min(goal, state.done + 1) }));
  const reset = () => setState((state) => ({ ...state, done: 0 }));

  return {
    done: state.done,
    percent: (state.done / goal) * 100,
    isComplete,
    add,
    reset,
  };
}
